import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './style.css'
import TopTip from './components/TopTip.vue'
import { formatDict } from '@/utils/common'

Vue.filter('dictFormat', formatDict)
Vue.config.productionTip = false

// 全局提示组件
const TipConstructor = Vue.extend(TopTip)
let tipInstance = null

// 全局 $topTip 方法
function $topTip(options) {
  // 1. 如果已有实例，先关闭并清理（不立即销毁，交给组件自己管理）
  if (tipInstance) {
    tipInstance.close()
  }

  // 2. 创建新实例
  tipInstance = new TipConstructor({
    el: document.createElement('div')
  })

  document.body.appendChild(tipInstance.$el)

  // 3. 配置参数
  const config = typeof options === 'string' ? { message: options } : options
  Object.assign(tipInstance, {
    message: config.message || '',
    type: config.type || 'info',
    duration: config.duration !== undefined ? config.duration : 3000,
    showClose: config.showClose || false,
    customClass: config.customClass || ''
  })

  // 4. 打开提示
  tipInstance.open()

  // 5. 关闭后清理 DOM
  tipInstance.$once('close', () => {
    setTimeout(() => {
      if (tipInstance?.$el?.parentNode) {
        tipInstance.$el.parentNode.removeChild(tipInstance.$el)
        tipInstance.$destroy()
      }
      tipInstance = null
    }, 300) // 等待动画完成
  })

  return tipInstance
}

Vue.prototype.$topTip = $topTip

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')